import { genericMap2LegacyTheme } from './genericMap2LegacyTheme';
import { genericMap2Tokens } from './genericMap2Tokens';
import { propAdapter } from './propAdapter';
const map = {
  neutral10: '--st-dt-color-neutral-10',
  // #e8eaee
  neutral20: '--st-dt-color-neutral-20',
  // #d1d5da
  neutral30: '--st-dt-color-neutral-30',
  // #b9c0c8
  neutral40: '--st-dt-color-neutral-40',
  // #a2abb5
  neutral50: '--st-dt-color-neutral-50',
  // #8b96a3
  neutral60: '--st-dt-color-neutral-60',
  // #737e8b
  neutral70: '--st-dt-color-neutral-70',
  // #56616c
  neutral80: '--st-dt-color-neutral-80',
  // #394451
  neutral90: '--st-dt-color-neutral-90',
  // #232f3e
  neutral100: '--st-dt-color-neutral-100',
  // #161e2d
  neutral0: '--st-dt-color-neutral-00',
  // #ffffff
  neutral05: '--st-dt-color-neutral-05',
  // #f1f4f7
  primary10: '--st-dt-color-blue-10',
  // #d7ebfb
  primary20: '--st-dt-color-blue-20',
  // #afd7f7
  primary30: '--st-dt-color-blue-30',
  // #87c2f4
  primary40: '--st-dt-color-blue-40',
  // #5faef0
  primary50: '--st-dt-color-blue-50',
  // #379aec
  primary60: '--st-dt-color-blue-60',
  // #0077d9
  primary70: '--st-dt-color-blue-70',
  // #1768c9
  primary80: '--st-dt-color-blue-80',
  // #1659a9
  primary90: '--st-dt-color-blue-90',
  // #123b74
  primary05: '--st-dt-color-blue-05',
  // #ebf5fd
  green10: '--st-dt-color-green-10',
  // #d7f3ed
  green20: '--st-dt-color-green-20',
  // #afe7db
  green30: '--st-dt-color-green-30',
  // #86dac9
  green40: '--st-dt-color-green-40',
  // #5eceb7
  green50: '--st-dt-color-green-50',
  // #00a890
  green60: '--st-dt-color-green-60',
  // #008574
  green70: '--st-dt-color-green-70',
  // #23756b
  green80: '--st-dt-color-green-80',
  // #195f57
  green90: '--st-dt-color-green-90',
  // #104643
  green05: '--st-dt-color-green-05',
  // #ebf9f6
  red10: '--st-dt-color-red-10',
  // #fde1df
  red20: '--st-dt-color-red-20',
  // #fbc3bf
  red30: '--st-dt-color-red-30',
  // #f8a49e
  red40: '--st-dt-color-red-40',
  // #f6867e
  red50: '--st-dt-color-red-50',
  // #f4685e
  red60: '--st-dt-color-red-60',
  // #da3733
  red70: '--st-dt-color-red-70',
  // #bb2929
  red80: '--st-dt-color-red-80',
  // #9a1818
  red90: '--st-dt-color-red-90',
  // #710400
  red05: '--st-dt-color-red-05',
  // #fef0ef
  yellow10: '--st-dt-color-yellow-10',
  // #fff3cc
  yellow20: '--st-dt-color-yellow-20',
  // #ffe799
  yellow30: '--st-dt-color-yellow-30',
  // #ffdc66
  yellow40: '--st-dt-color-yellow-40',
  // #ffd033
  yellow50: '--st-dt-color-yellow-50',
  // #ffc400
  yellow60: '--st-dt-color-yellow-60',
  // #ca8700
  yellow70: '--st-dt-color-yellow-70',
  // #b27400
  yellow80: '--st-dt-color-yellow-80',
  // #8e5d00
  yellow90: '--st-dt-color-yellow-90',
  // #684500
  yellow05: '--st-dt-color-yellow-05',
  // #fff9e6
  pink10: '--st-dt-color-pink-10',
  // #f3deeb
  pink20: '--st-dt-color-pink-20',
  // #e8bdd7
  pink30: '--st-dt-color-pink-30',
  // #dd9cc4
  pink40: '--st-dt-color-pink-40',
  // #d27bb0
  pink50: '--st-dt-color-pink-50',
  // #cf6ba0
  pink60: '--st-dt-color-pink-60',
  // #ba3385
  pink70: '--st-dt-color-pink-70',
  // #a90067
  pink80: '--st-dt-color-pink-80',
  // #8b065b
  pink90: '--st-dt-color-pink-90',
  // #6e0c4f
  pink05: '--st-dt-color-pink-05',
  // #faf2f7
  purple10: '--st-dt-color-purple-10',
  // #f2e4fb
  purple20: '--st-dt-color-purple-20',
  // #e5c8f7
  purple30: '--st-dt-color-purple-30',
  // #d9adf2
  purple40: '--st-dt-color-purple-40',
  // #cc91ee
  purple50: '--st-dt-color-purple-50',
  // #bf76ea
  purple60: '--st-dt-color-purple-60',
  // #a249e0
  purple70: '--st-dt-color-purple-70',
  // #8b46c6
  purple80: '--st-dt-color-purple-80',
  // #7037a3
  purple90: '--st-dt-color-purple-90',
  // #51267f
  purple05: '--st-dt-color-purple-05',
  // #f9f1fd
  'neutral100-alpha10': '--st-legacy-color-neutral100-alpha10',
  // rgba(35, 47, 62, 0.1)
  'neutral100-alpha30': '--st-legacy-color-neutral100-alpha30',
  // rgba(35, 47, 62, 0.3)
  'neutral100-alpha50': '--st-legacy-color-neutral100-alpha50',
  // rgba(35, 47, 62, 0.5)
  'neutral100-alpha70': '--st-legacy-color-neutral100-alpha70',
  // rgba(35, 47, 62, 0.7)
  'neutral100-alpha90': '--st-legacy-color-neutral100-alpha90',
  // rgba(35, 47, 62, 0.9)

  'neutral0-alpha10': '--st-legacy-color-neutral0-alpha10',
  // rgba(255, 255, 255, 0.1)
  'neutral0-alpha30': '--st-legacy-color-neutral0-alpha30',
  // rgba(255, 255, 255, 0.3)
  'neutral0-alpha50': '--st-legacy-color-neutral0-alpha50',
  // rgba(255, 255, 255, 0.5)
  'neutral0-alpha70': '--st-legacy-color-neutral0-alpha70',
  // rgba(255, 255, 255, 0.7)
  'neutral0-alpha90': '--st-legacy-color-neutral0-alpha90',
  // rgba(255, 255, 255, 0.9)

  'primary60-alpha10': '--st-legacy-color-primary60-alpha10',
  // rgba(0, 119, 217, 0.1)
  'primary60-alpha30': '--st-legacy-color-primary60-alpha30',
  // rgba(0, 119, 217, 0.3)
  'primary60-alpha50': '--st-legacy-color-primary60-alpha50',
  // rgba(0, 119, 217, 0.5)
  'primary60-alpha70': '--st-legacy-color-primary60-alpha70',
  // rgba(0, 119, 217, 0.7)
  'primary60-alpha90': '--st-legacy-color-primary60-alpha90',
  // rgba(0, 119, 217, 0.9)

  'green60-alpha10': '--st-legacy-color-green60-alpha10',
  // rgba(0, 133, 116, 0.1)
  'green60-alpha30': '--st-legacy-color-green60-alpha30',
  // rgba(0, 133, 116, 0.3)
  'green60-alpha50': '--st-legacy-color-green60-alpha50',
  // rgba(0, 133, 116, 0.5)
  'green60-alpha70': '--st-legacy-color-green60-alpha70',
  // rgba(0, 133, 116, 0.7)
  'green60-alpha90': '--st-legacy-color-green60-alpha80',
  // rgba(0, 133, 116, 0.9)

  'yellow50-alpha10': '--st-legacy-color-yellow50-alpha10',
  // rgba(255, 196, 0, 0.1)
  'yellow50-alpha30': '--st-legacy-color-yellow50-alpha30',
  // rgba(255, 196, 0, 0.3)
  'yellow50-alpha50': '--st-legacy-color-yellow50-alpha50',
  // rgba(255, 196, 0, 0.5)
  'yellow50-alpha70': '--st-legacy-color-yellow50-alpha70',
  // rgba(255, 196, 0, 0.7)
  'yellow50-alpha90': '--st-legacy-color-yellow50-alpha90',
  // rgba(255, 196, 0, 0.9)

  'red60-alpha10': '--st-legacy-color-red60-alpha10',
  // rgba(218, 55, 51, 0.1)
  'red60-alpha30': '--st-legacy-color-red60-alpha30',
  // rgba(218, 55, 51, 0.3)
  'red60-alpha50': '--st-legacy-color-red60-alpha50',
  // rgba(218, 55, 51, 0.5)
  'red60-alpha70': '--st-legacy-color-red60-alpha70',
  // rgba(218, 55, 51, 0.7)
  'red60-alpha90': '--st-legacy-color-red60-alpha90',
  // rgba(218, 55, 51, 0.9)

  'pink60-alpha10': '--st-legacy-color-pink60-alpha10',
  // rgba(186, 51, 133, 0.1)
  'pink60-alpha30': '--st-legacy-color-pink60-alpha30',
  // rgba(186, 51, 133, 0.3)
  'pink60-alpha50': '--st-legacy-color-pink60-alpha50',
  // rgba(186, 51, 133, 0.5)
  'pink60-alpha70': '--st-legacy-color-pink60-alpha70',
  // rgba(186, 51, 133, 0.7)
  'pink60-alpha90': '--st-legacy-color-pink60-alpha90',
  // rgba(186, 51, 133, 0.9)

  'purple60-alpha10': '--st-legacy-color-purple60-alpha10',
  // rgba(162, 73, 224, 0.1)
  'purple60-alpha30': '--st-legacy-color-purple60-alpha30',
  // rgba(162, 73, 224, 0.3)
  'purple60-alpha50': '--st-legacy-color-purple60-alpha50',
  // rgba(162, 73, 224, 0.5)
  'purple60-alpha70': '--st-legacy-color-purple60-alpha70',
  // rgba(162, 73, 224, 0.7)
  'purple60-alpha90': '--st-legacy-color-purple60-alpha90' // rgba(162, 73, 224, 0.9)
};
export const map2Tokens = legacyThemeProperty => {
  return genericMap2Tokens(legacyThemeProperty, map);
};
export const map2LegacyTheme = (tokens, legacyThemeProperty) => {
  return genericMap2LegacyTheme(tokens, legacyThemeProperty, map);
};
export const colorPropAdapter = propAdapter(map);